<template>
    <div>
        <a-row type="flex" style="margin-bottom: 12px">
            <a-col><strong style="font-size: 25px">Penilaian {{ title }}</strong></a-col>
        </a-row>

        <common-training-header style="margin-bottom: 12px"/>

        <a-row type="flex" style="margin-bottom: 12px">
            <a-col>
                <strong style="font-size: 25px">Peserta</strong>
            </a-col>
        </a-row>

        <a-card type="inner" size="small">
            <a-table
                :columns="columns"
                :dataSource="items.attendants"
                rowKey="hash"
                :loading="loading"
                :pagination="false">

                <div slot="name" slot-scope="record">
                    {{ record.name }}
                </div>

                <div slot="count" slot-scope="record">
                </div>

                <div slot="file" slot-scope="record">
                    <a-button type="link" size="small" >
                        <a-icon type="file-word" theme="twoTone" two-tone-color="#3452eb" /> Download
                    </a-button>
                </div>

                <div slot="upload_at" slot-scope="record">
                    
                </div>

                <div slot="history" slot-scope="record">
                    <a-button icon="solution" size="small" @click="revision(record.hash)" />
                </div>

            </a-table>
        </a-card>
    </div>
</template>

<script>
    const columns = [
        {
            key: 'name',
            title: 'Nama Peserta',
            scopedSlots: {customRender: 'name'},
        }, {
            key: 'team',
            title: 'Tim Penilai',
            scopedSlots: {customRender: 'team'}
        }, {
            key: 'notulen',
            title: 'Notulen Ujian',
            scopedSlots: {customRender: 'notulen'}
        }, {
            key: 'prj_charter',
            title: 'Project Charter',
            scopedSlots: {customRender: 'prj_charter'}
        }, {
            key: 'score',
            title: 'Penilaian',
            scopedSlots: {customRender: 'raw_score'},
            children: [
                {
                    key: 'presentasi',
                    title: 'Presentasi',
                    scopedSlots: {customRender: 'presentasi'},
                },
                {
                    key: 'isi',
                    title: 'Isi',
                    scopedSlots: {customRender: 'isi'},
                },
                {
                    key: 'penulisan',
                    title: 'Penulisan',
                    scopedSlots: {customRender: 'penulisan'},
                },
            ]
        }, {
            key: 'recap',
            title: 'Nilai Rekap',
            scopedSlots: {customRender: 'recap'}
        }, {
            key: 'file',
            title: 'File Makalah',
            scopedSlots: {customRender: 'file'}
        }
    ]

    export default {
        props: {
            outline: {
                type: String,
                required: true
            },
        },
        data() {
            return {
                columns,
                items: {
                    outline: {
                        title: ''
                    },
                    attendants: []
                },
                loading: false,
            }
        },
        created() {
            //this.getItems()
        },
        computed: {
            activeModule() {
                return this.$laravel.active_module
            },
            title(){
                switch(this.outline) {
                    case "proposal": 
                        return "Proposal"
                    case "project_evaluation":
                        return "Evaluasi Project"
                    default: 
                        return "Makalah"
                }
            }
        },
        methods: {
            getItems() {
                this.loading = true;

                let params = this.activeModule.module.identifier == 'paper' ? null : {
                    params: {
                        outline: this.outline
                    }
                }

                this.$http
                    .get(this.routeUri("api.activity-notulens.attendants", { outline: this.hash }), params)
                    .then(response => this.items = response.data)
                    .catch(error => this.handleXhrError(error))
                    .finally(() => (this.loading = false));
            },
            download(url) {
                window.open(window.location.origin + url, '_blank')
            },
            revision(attendant){
                let params = {
                    outline: this.outline,
                }

                window.location.href = this.routeUri('admin.' + this.activeModule.module.identifier + '.guidance.revision') + '?' + this.$qs.stringify(params)
            },
        }
    }
</script>